import React, { useEffect, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"
import axios from 'axios';
import Paginations from './Paginations';

function AllExpenses() {
          const { currentLocal } = useSelector((state) => state.currentLocal);
              const userinfo = useSelector((state) => state);
const [items, setItems] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationsItems, setPaginationsItems] = useState(null)

            //   const [items, setItems] = useState([{
            //     id:0,name:"الابتدائية",email:"الصف الأول",phone:"10000"
            //   },
            // {
            //     id:1,name:"الاعدادية",phone:"15000",email:"الصف الثاني"
            //   },
            //   {
            //     id:2,name:"الثانوية",phone:"20000",email:"الصف الثالث"
            //   }
            // ])

    const headerIterm = [
        currentLocal.home.ID,
        currentLocal.home.stageName,
        currentLocal.home.gradeName,
        currentLocal.home.price,
        currentLocal.home.addExceptions,
        currentLocal.home.showExceptions,

        "",

   ]
   useEffect(() => {
const getData=async()=>{

try {
            await axios
                .get(`https://nanosoft.space/taarteb/public/api/admin/expenses?paginated=10&page=${currentPage}`, {
                    headers: {
                        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                    }
                })
                .then(async (res) => {
                  
console.log(res.data.data);
        setPaginationsItems(res.data.data);

// const option = res.data.data.data.map((item) => ({
//   label: item?.name,
//   value: item?.id
// }));
setItems(res?.data?.data?.data)
                })
                .catch((error) => {


                });
} catch (error) {
  console.log(error);
  
}
}
getData()
   }, [currentPage])
     const printTable = () => {
        const content = document.getElementById("financialTable").innerHTML;

        const printWindow = window.open("", "_blank", "width=900,height=700");
        printWindow.document.write(`
    <html dir="rtl">
      <head>
        <title>${currentLocal.home.FinanceReport}</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
        <style>
          body {
            font-family: Arial, sans-serif;
            direction: rtl;
            padding: 20px;
          }
          .fw-bold {
            font-weight: bold;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          table, th, td {
            border: 1px solid #000;
          }
          th, td {
            padding: 8px;
            text-align: center;
          }
          th {
            background-color: #f8f8f8;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };
    console.log(paginationsItems,currentPage);
    
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
    <Container>
        <div className="d-flex flex-column w-100">
            
            <AuthNavbar />
            <div className="mt-5 mx-3">
                <HomeTitle title={currentLocal.home.Studyexpenses} />
                <ExportBox
                                   title={""}
                    paragrapg={' '}
                    addingBtn={currentLocal.home.add}
                    exportState={false}
                />
<Row>
                  <div>
                    
                          <button onClick={printTable} className="btn  border mb-3 mt-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
                                <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                            </svg>
                        </button>
                  </div>

</Row>
                        <div id="financialTable">

                <Table
                    data={items&&items}
                    headerIterm={headerIterm}
                    actions={["edit"]}
                    addExceptions={true}
                    showExceptions={true}
                    // onDataChanged={getAllApis}
                />
                <Paginations
  total={paginationsItems?.last_page}
  currentPage={currentPage}
  onPageChange={(page) => setCurrentPage(page)}
/>

</div>

            </div>

        </div>
    </Container>
</div>)
}

export default AllExpenses